export default __webpack_public_path__ + "static/monetisation-7e881df19e1c4bc3fb7218ea24e44676.png";